import Top from "./pages/top/Top";
import Coliseum from "./pages/coliseum/Coliseum";
import NinetyNine from "./pages/ninetyNine/NinetyNine";
import PlayerVersusPlayer from "./pages//playerVersusPlayer/PlayerVersusPlayer";
import Quest from "./pages/quest/Quest";
import { BrowserRouter as Router, Route } from "react-router-dom";
import BattleResult from "./pages/top/BattleResult";
import BattleTeamProvider from "./context/battleTeam/BattleTeamProvider";
import AssetProvider from "./context/asset/AssetProvider";

function App() {
  return (
    <div className="App">
      <BattleTeamProvider>
        <AssetProvider>
          <Router>
            <Route exact path="/" component={Top} />
            <Route exact path="/playerVersusPlayer/battleResult" component={BattleResult} />
            <Route exact path="/coliseum" component={Coliseum} />
            <Route exact path="/ninetyNine" component={NinetyNine} />
            <Route
              exact
              path="/playerVersusPlayer"
              component={PlayerVersusPlayer}
            />
            <Route exact path="/quest" component={Quest} />
          </Router>
        </AssetProvider>
      </BattleTeamProvider>
    </div>
  );
}

export default App;
